// Angular libray
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Local library
import { DepositWireTransferService } from '@amwager/funding/data-access';
import { TranslatePipe } from '@amwager/util';

@Component({
  selector: 'feature-mat-wire-transfer',
  templateUrl: './wire-transfer.component.html',
  styleUrls: ['./wire-transfer.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [DepositWireTransferService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WireTransferComponent implements OnInit {

  wireTransferForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.wireTransferForm?.controls }

  amount!: number;

  ngOnInit() {
    null;
  }

}
